export default __webpack_public_path__ + "static/media/TestLeft-Logo.aef30e8f.svg";